import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Trash2 } from 'lucide-react';

export const DeleteDriverDialog = ({ open, onOpenChange, driverToDelete, deleteLoading, onConfirm, onCancel }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle className="text-red-600 flex items-center gap-2">
          <Trash2 className="h-5 w-5" />
          Delete Driver
        </DialogTitle>
        <DialogDescription>
          Are you sure you want to delete this driver? This action cannot be undone.
        </DialogDescription>
      </DialogHeader>
      <div className="py-4">
        {driverToDelete && (
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="font-medium text-red-900">{driverToDelete.driver_name}</p>
            <p className="text-sm text-red-700">Owner: {driverToDelete.owner_name}</p>
            {driverToDelete.driver_id_number && (
              <p className="text-sm text-red-600">ID: {driverToDelete.driver_id_number}</p>
            )}
          </div>
        )}
        <p className="text-sm text-muted-foreground mt-4">
          All associated data including contracts, statements, and documents will be permanently deleted.
        </p>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={onCancel}>Cancel</Button>
        <Button
          type="button"
          variant="destructive"
          onClick={onConfirm}
          disabled={deleteLoading}
          data-testid="confirm-delete-driver"
        >
          {deleteLoading ? 'Deleting...' : 'Delete Driver'}
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
